module.exports = __webpack_public_path__ + "static/WEDDING E&M-446-d5646f257e9bae1859950d71fa029008.jpg";